export default [
  {
    "id": "50",
    "name": "会员管理",
    "path": "MemberManage",
    "icon": "icon-huiyuanguanli",
    "children": [
      {
        "id": "503001",
        "name": "会员",
        "path": "/MemberManage/MemberList"
      },
      {
        "id": "5110",
        "name": "卡管理",
        "path": "/MemberManage/CardManage",
        "children": [
          {
            "id": "502001",
            "name": "会员卡",
            "path": "/MemberManage/CardManage",
            "tabName": 'MemberCardList'
          },
          {
            "id": "51100101",
            "name": "匿名卡",
            "path": "/MemberManage/CardManage/AnonymousCardList",
            "tabName": 'AnonymousCardList'
          }
          //          {
          //            "id": "502011",
          //            "name": "卡类型",
          //            "path": "/MemberManage/MemberCard/MemberCardType",
          //            "tabName": 'MemberCardType'
          //          }
        ]
      },
      {
        "id": "5090",
        "name": "微会员中心",
        "path": "/MemberManage/MicroMember",
        "children": [
          {
            "id": "509004",
            "name": "授权",
            "path": "/MemberManage/MicroMember",
            "tabName": "Authorization"
          },
          {
            "id": "509005",
            "name": "微会员卡设置",
            "path": "/MemberManage/MicroMember/Setting",
            "tabName": "Setting"
          },
          {
            "id": "509006",
            "name": "关注自动回复",
            "path": "/MemberManage/MicroMember/Attention",
            "tabName": "Attention"
          }
        ]
      },
      {
        "id": "5100",
        "name": "卡权益",
        "path": "/MemberManage/CardRights",
        "children": [
          {
            "id": "510001",
            "name": "会员卡",
            "path": "/MemberManage/CardRights",
            "tabName": 'CardBenefits'
          },{
            "id": "51000602",
            "name": "匿名卡",
            "path": "/MemberManage/CardRights/CardAnonymous",
            "tabName": 'CardAnonymous'
          }
        ]
      },
      {
        "id": "5080",
        "name": "批量制卡",
        "path": "/MemberManage/BatchCard",
        "children": [
          {
            "id": "508004",
            "name": "会员卡",
            "path": "/MemberManage/BatchCard/BatchCardList",
            "tabName": 'BatchCardList'
          },
          {
            "id": "50800601",
            "name": "匿名卡",
            "path": "/MemberManage/BatchCard/AnonymousBatchCard",
            "tabName": 'AnonymousBatchCard'
          }
        ]
      },
      {
        "id": "506002",
        "name": "交易明细",
        "path": "/MemberManage/TransactionDetail"
      },
      {
        "id": "507002",
        "name": "会员标签",
        "path": "/MemberManage/MemberLabel"
      }
    ]
  },
  {
    "id": "180",
    "name": "全渠道会员",
    "path": "FullChannel",
    "icon": "icon-tongjibaobiao",
    "children": [
      {
        "id": "1801101",
        "name": "业务开通",
        "path": "/FullChannel/v1/BusinessOpen"
      }, {
        "id": "1801200",
        "name": "业务开通",
        "path": "/FullChannel/v1/HqBusinessOpen"
      }, {
        "id": "1801302",
        "name": "会员档案",
        "path": "/FullChannel/v1/MemberArchive"
      }, {
        "id": "1801402",
        "name": "活动管理",
        "path": "/FullChannel/v1/ActivityManage"
      },
      {
        "id": "1802102",
        "name": "概览",
        "path": "/FullChannel/Summary"
      },
      {
        "id": "1802202",
        "name": "营销中心",
        "path": "/FullChannel/MarketingCenter",
        "lx": {
          "bid": "b_hitb0va2",
          "cid": "c_0cuwhb94",
        }
      },
      {
        "id": "1802302",
        "name": "活动管理",
        "path": "/FullChannel/ActivityManage",
        "lx": {
          "bid": "b_xn0s4yww",
          "cid": 'c_cg2f6j1c'
        }
      },
      {
        "id": "1802402",
        "name": "会员分析",
        "path": "/FullChannel/ActivityAnalysis"
      },
      {
        "id": "1802501",
        "name": "业务开通",
        "path": "/FullChannel/BusinessOpen",
        "lx": {
          "bid": "b_gnzyn50n",
          "cid": "c_l5ugbfub",
        }
      },
      {
        "id": "1802600",
        "name": "业务开通",
        "path": "/FullChannel/BusinessOpen-BD"
      },
    ]
  },
  {
    "id": "150",
    "name": "营销活动",
    "path": "MarketingManage",
    "icon": "icon-yingxiaoguanli",
    "children": [
      {
        "id": "1501001",
        "name": "优惠券管理",
        "path": "/MarketingManage/Coupon"
      },
      {
        "id": "1502003",
        "name": "会员活动",
        "path": "/MarketingManage/ActivityAdd"
      },
      // {
      //   "id": "15060",
      //   "name": "促销活动",
      //   "path": "/MarketingManage/PromotionAdd"
      // },
      {
        "id": "1503001",
        "name": "会员活动管理",
        "path": "/MarketingManage/ActivityList"
      },
      // {
      //   "id": "15030",
      //   "name": "营销活动管理",
      //   "path": "/MarketingManage/PromotionList",
      // },
      // {
      //   "id": "1504001",
      //   "name": "活动统计",
      //   "path": "/MarketingManage/Analysis"
      // },
      {
        "id": "15050",
        "name": "短信设置",
        "path": "/MarketingManage/Message",
        "children": [
          {
            "id": "1505002",
            "name": "短信模板",
            "path": "/MarketingManage/Message",
            "tabName": "MessageMould"
          },
          {
            "id": "1505004",
            "name": "短信配置",
            "path": "/MarketingManage/Message/MessageConfig",
            "tabName": "MessageConfig"
          }
        ]
      },
      {
        "id": "15060",
        "name": "积分兑换",
        "path": "/MarketingManage/CreditsExchange",
        "children": [
          {
            "id": "1506003",
            "name": "积分兑换明细",
            "path": "/MarketingManage/CreditsExchange/ExchangeDetail",
            "tabName": "ExchangeDetail"
          },
          {
            "id": "1506002",
            "name": "积分兑换方案",
            "path": "/MarketingManage/CreditsExchange/ExchangePlan",
            "tabName": "ExchangePlan"
          },
          {
            "id": "1506001",
            "name": "积分兑换",
            "path": "/MarketingManage/CreditsExchange/Exchange",
            "tabName": "Exchange"
          }
        ]
      }
    ]
  },
  {
    "id": "140",
    "name": "经营分析",
    "path": "BizAnalysis",
    "icon": "icon-jingyingfenxi",
    "children": [
      {
        "id": "1401001",
        "name": "会员分析",
        "path": "/BizAnalysis/MemberAnalysis"
      }
      // {
      //   "id": "1401001",
      //   "name": "会员基本属性",
      //   "path": "/BizAnalysis/MemberProperty"
      // },
      // {
      //   "id": "1401001",
      //   "name": "会员消费模型",
      //   "path": "/BizAnalysis/MemberConsumeModel"
      // },
      // {
      //   "id": "1401001",
      //   "name": "最有价值会员",
      //   "path": "/BizAnalysis/ValuableMember"
      // }
    ]
  },
  {
    "id": "160",
    "name": "统计报表",
    "path": "ReportManage",
    "icon": "icon-tongjibaobiao",
    "children": [
      {
        "id": "1601001",
        "name": "储值汇总表",
        "path": "/ReportManage/StoredValueSummary"
      },
      {
        "id": "1602001",
        "name": "储值支付方式组成表",
        "path": "/ReportManage/PaymentComposition"
      },
      {
        "id": "1603001",
        "name": "储值余额汇总表",
        "path": "/ReportManage/StoredValueBalance"
      },
      {
        "id": "1604001",
        "name": "门店结算报表",
        "path": "/ReportManage/StoreSettlement"
      },
      {
        "id": "1606001",
        "name": "门店储值现金结算表",
        "path": "/ReportManage/CashSettlement"
      },
      {
        "id": "1607001",
        "name": "门店储值交易结算表",
        "path": "/ReportManage/TradeSettlement"
      },
      {
        "id": "1605001",
        "name": "积分结算报表",
        "path": "/ReportManage/IntegralSettlement"
      }
      // {
      //   "id": "1605001",
      //   "name": "门店储值现金结算表",
      //   "path": "/ReportManage/CashBalance"
      // }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/constants/menu.js